<template>
    <div class="box clone">
        <el-dialog :title="title" :visible="dialogFormVisible" width="40%" :before-close="handleClose" :closeOnClickModal="false">
            <div class="top">
                <h1>当前设备: <span>{{deviceName}}</span></h1>
                <h1>设备类型: <span>{{deviceType}}</span></h1>
            </div>
            <el-form :inline="true" class="user-search" style="text-align:left">
                <el-form-item label="选择单位">
                    <el-select v-model="companyModel.SearchKey" @change="handleSearchCompany" filterable remote reserve-keyword placeholder="请输入单位查询" :remote-method="remoteMethod1" :disabled="isdisabled">
                        <el-option v-for="item in companyList" :key="item.OID" :label="item.Name" :value="item.OID">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择设备">
                    <el-select v-model="deviceModel.SearchKey" @change="handleSearchDevice" filterable remote reserve-keyword placeholder="请输入设备名称查询" :remote-method="remoteMethod2" :disabled="isdisabled">
                        <el-option v-for="item in deviceList" :key="item.OID" :label="item.DeviceName" :value="item.OID">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div class="right">
                <el-table ref="table" :data="appList" style="width: 100%;margin-bottom: 20px;" row-key="KID" border @selection-change="changeFun">
                    <el-table-column type="selection" sortable width="40">
                    </el-table-column>
                    <el-table-column prop="AppShowName" label="应用名称" sortable width="180">
                    </el-table-column>
                    <el-table-column prop="AppVersion" label="版本号">
                    </el-table-column>
                    <el-table-column prop="AppType" label="应用类型">
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='handleClose'>取消</el-button>
                <el-button size="small" type="primary" class="title" @click="handleSave">一键克隆</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { GetDeviceList, AddDeviceApp, GetDeviceAppList } from '../../../api/device'
    import { GetAppVersionInfo } from '../../../api/app'
    import { GetCompanyList } from '../../../api/company'
    export default {
        data() {
            return {
                title: '克隆应用',
                appList: [],
                isdisabled: false,
                listCount: Number,
                appModel: {
                    Page: 1,
                    Rows: 100,
                    SearchKey: '',
                    OID: null
                },
                deviceModel: {
                    Page: 1,
                    Rows: 10,
                    SearchKey: '',
                    CompanyID: 0,
                    DeviceType: null
                },
                companyModel: {
                    Page: 1,
                    Rows: 10,
                    SearchKey: '',
                },
                model: {
                    DeviceID: null,
                    AppIds: [],
                },
                deviceList: [],
                companyList: [],
                multipleSelection: []
            }
        },
        props: {
            dialogFormVisible: {
                required: true,
                type: Boolean
            },
            deviceType: {
                required: true
            },
            deviceName: {
                required: true
            },
            companyName: {
                required: true
            },
            DeviceID: {
                required: true
            },
            CompanyID: {
                required: true
            }
        },
        mounted() {
            this.deviceModel.DeviceType = this.deviceType;
            this.model.DeviceID = this.DeviceID;
            this.deviceModel.CompanyID = this.CompanyID;
            this.companyModel.SearchKey = this.companyName;
        },
        methods: {
            handleClose() {
                this.$emit('closeCloneDialog')
            },
            GetDeviceAppList() {
                GetDeviceAppList(this.appModel).then(data => {
                    if (!data.iserror) {
                        this.appList = data.data.List;
                        this.$nextTick(() => {
                            this.appList.forEach(item => {
                                this.$refs.table.toggleRowSelection(item, true)
                            })
                        })
                    }
                })
            },
            GetDeviceList() {
                GetDeviceList(this.deviceModel).then(data => {
                    if (!data.iserror) {
                        this.deviceList = data.data.List;
                    }
                })
            },
            handleSearchDevice(val) {
                this.appModel.OID = val;
                this.GetDeviceAppList();
            },
            GetCompanyList() {
                GetCompanyList(this.companyModel).then(data => {
                    if (!data.iserror) {
                        this.companyList = data.data.List;
                    }
                })
            },
            remoteMethod1(query) {
                this.companyModel.SearchKey = query;
                this.GetCompanyList();
            },
            remoteMethod2(query) {
                if (!this.deviceModel.CompanyID) {
                    this.deviceModel.SearchKey = '';
                    this.deviceList = [];
                    return false;
                } else {
                    this.deviceModel.SearchKey = query;
                    this.GetDeviceList();
                }
            },
            handleSave() {
                console.log(this.multipleSelection)
                if (this.multipleSelection.length > 0) {
                    this.multipleSelection.forEach(item => {
                        console.log('item.AppLogID')
                        console.log(item.AppLogID)
                        this.model.AppIds.push(item.AppLogID)
                    })
                    console.log('提交数据')
                    this.AddDeviceApp();
                }
            },
            //搜索单位发生改变
            handleSearchCompany(val) {
                this.deviceModel.CompanyID = val;
                this.deviceList = [];
                this.deviceModel.SearchKey = '';
            },
            AddDeviceApp() {
                console.log(this.model)
                AddDeviceApp(this.model).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        this.handleClose();
                    }
                })
            },
            changeFun(val) {
                this.multipleSelection = val // 返回的是选中的列的数组集合
            },
        }
    }
</script>

<style socped>
    .box .top {
        display: flex;
        align-items: center;
    }

    .box .top h1 {
        margin-right: 30px;
        font-size: 18px;
    }

    .el-dialog__body {
        padding-top: 10px;
    }
</style>
